<template>
    <v-row class="ma-ne">
        <v-col cols="12" class="pa-2">
            <digikey-credentials v-bind="{ value }" v-on="{ input }" />
        </v-col>
        <v-col cols="12" class="pa-2">
            <digikey-headers v-bind="{ value }" v-on="{ input }" />
        </v-col>
    </v-row>
</template>

<script>
import { initManufacturingVendorDigikey } from "@/assets/variables/inits";

import DigikeyCredentials from "./digikey/digikey-credentials.vue";
import DigikeyHeaders from "./digikey/digikey-headers.vue";

export default {
    components: {
        DigikeyCredentials,
        DigikeyHeaders,
    },
    props: {
        value: { type: Object, default: initManufacturingVendorDigikey },
    },
    methods: {
        input(form) {
            this.$emit("input", form);
        },
    },
};
</script>
